import { apiClient } from "./apiClient";

export const userService = {
    async getSubscription() {
        return apiClient("/users/me/subscription", {
            method: "GET"
        });
    },

    async getMe() {
        return apiClient("/users/me", {
            method: "GET"
        });
    },

    async updateActiveWorkspace(workspaceId) {
        return apiClient("/users/me/active-workspace", {
            method: "PATCH",
            body: { workspaceId }
        });
    },

    async acceptTerms(version) {
        return apiClient("/users/me/terms", {
            method: "POST",
            body: { version }
        });
    },

    async updateShoppingListSelection(listId) {
        return apiClient("/users/me/shopping-list-selection", {
            method: "PATCH",
            body: { listId }
        });
    }
};
